export default __webpack_public_path__ + "static/passion-2cd8cf220e4af44d35ae63778c95b073.jpg";